@if (error) {
<app-alert (close)="error = null" type="error" class="mt-3">{{
  error
}}</app-alert>
}

@if (bankingDetails) {
<div class="d-flex justify-content-end mt-2 mb-4">
  Status:
  <div class="ms-2 me-2">{{ utils.getStatus(bankingDetails.status) }}</div>
  <mat-icon class="{{ utils.getStatusColor(bankingDetails.status) }}">
    {{ utils.getStatusIcon(bankingDetails.status) }}
  </mat-icon>
</div>

<div class="ms-3">
  <display-input title="Bank Name" [value]="bankingDetails.bankName" />
  <display-input
    title="Account Number"
    [value]="bankingDetails.accountNumber"
  />
  <display-input title="Account Type" [value]="bankingDetails.accountType" />
  <display-input title="Branch Code" [value]="bankingDetails.branchCode" />
</div>
<div class="d-flex align-items-center justify-content-end mt-3">
  @if (loading) {
  <mat-progress-spinner mode="indeterminate" color="primary" diameter="30" />
  } @else {
  <div class="d-flex align-items-center">
    <button
      (click)="onDeclineClicked()"
      [disabled]="bankingDetails.status == 'declined'"
      mat-raised-button
      color="warn"
      class="me-3 px-4"
    >
      Decline
    </button>

    <button
      (click)="onApproveClicked()"
      [disabled]="bankingDetails.status == 'approved'"
      mat-raised-button
      class="px-4"
    >
      Approve
    </button>
  </div>
  }
</div>
} @if (!bankingDetails) {
<div class="d-flex justify-content-center align-items-center h-100">
  <mat-icon class="me-2">home</mat-icon>
  <div>This user has not completed their banking details</div>
</div>
}
